import { Segment } from '../../../core/formBuilder/usePages';

export const calculateSegmentWidths = (segments: Segment[] = []) => {
  const defined = segments.filter((s) => s.width !== undefined);
  const totalDefined = defined.reduce((sum, s) => sum + (s.width as number), 0);
  const undefinedCount = segments.length - defined.length;

  // equal split if none defined
  if (defined.length === 0) {
    return segments.map(() => 100 / segments.length);
  }

  // distribute remaining equally if some defined
  const remaining = Math.max(100 - totalDefined, 0);
  const auto = undefinedCount > 0 ? remaining / undefinedCount : 0;

  return segments.map((s) => (s.width !== undefined ? s.width : auto));
};
